import React from 'react'

import { InfoBlock, InfoBlockRounded, InfoBlockType } from 'cng-common/components/infoBlock'
import { TInvalidFields } from 'cng-common/features/form/models'
import { Translation } from 'cng-common/features/translations'

import { ContactFormContent } from '../../../config/forms'
import { TContactGeneralForm } from '../../../model/forms/general'

export function renderValidationMessages(invalidFields: TInvalidFields<TContactGeneralForm>) {
  const messages = (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '0 16px' }}>
      {(Object.keys(invalidFields) as Array<keyof TInvalidFields<TContactGeneralForm>>).map(
        (key) => (
          <React.Fragment key={key}>
            <span key={`${key}-text`}>
              <Translation text={ContactFormContent.fields[key]?.label || '-'} span={true} />:
            </span>
            <span key={`${key}-field`}>{invalidFields[key]}</span>
          </React.Fragment>
        )
      )}
    </div>
  )

  return (
    <div style={{ gridColumn: '1/span 4' }}>
      <InfoBlock text={messages} rounded={InfoBlockRounded.Small} type={InfoBlockType.Danger} />
    </div>
  )
}
